import { render, staticRenderFns } from "./threeIndex.vue?vue&type=template&id=210d1ef9"
import script from "./threeIndex.vue?vue&type=script&lang=js"
export * from "./threeIndex.vue?vue&type=script&lang=js"
import style0 from "./threeIndex.vue?vue&type=style&index=0&id=210d1ef9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports